<script>
import CustomTooltip from '@/components/booking/bookingList/custom-tooltip.vue'

export default {
  name: 'SearchBookings',
  components: {
    CustomTooltip,
  },
  props: {
    isMobile: { type: Boolean, default: false },
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'search'],
  data() {
    return {
      showSearchBar: false,
      hideCloseIcon: false,
      internalText: this.modelValue || '',
    }
  },
  watch: {
    modelValue(val) {
      this.internalText = val
    },
    internalText(val) {
      this.$emit('update:modelValue', val)
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside, true)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true)
  },
  methods: {
    handleClickOutside(e) {
      // If search bar is visible and click is outside it
      if (this.showSearchBar && !this.$refs.searchInput.contains(e.target)) {
        if (!this.internalText.trim()) {
          this.hideCloseIcon = false
          this.closeSearchBar()
        } else {
          this.hideCloseIcon = true
        }
      }
    },
    openSearchBar() {
      this.showSearchBar = true
      this.$nextTick(() => this.$refs.searchInput?.focus())
    },
    closeSearchBar() {
      const oldInternalText = this.internalText
      this.internalText = ''
      this.$emit('update:modelValue', '')

      // only emit search if it changed
      if (oldInternalText !== '') {
        this.$emit('search', '')
      }
      this.showSearchBar = false
    },
    clearSearchBarAndClose() {
      this.internalText = ''
      this.showSearchBar = false
    },
  },
}
</script>

<template>
  <!-- Search -->
  <div
    v-if="showSearchBar"
    class="search-bar"
    :class="{ 'gray-input': hideCloseIcon }"
  >
    <v-icon v-if="!isMobile" size="20" class="search-magnify"
      >mdi-magnify</v-icon
    >

    <input
      ref="searchInput"
      v-model="internalText"
      class="ps-2 search-filter-input"
      data-search="search-box"
      style="outline: none"
      :placeholder="$t('client.clientSelectorSearchInputText')"
      @input="
        hideCloseIcon = false
        $emit('update:modelValue', internalText)
      "
      @keyup.enter="$emit('search', internalText)"
      @focus="hideCloseIcon = false"
    />

    <div
      v-if="!hideCloseIcon"
      class="cursor-pointer align-self-center"
      data-test="close-icon-wrapper"
      @click="closeSearchBar"
    >
      <CustomTooltip
        v-show="showSearchBar"
        position="bottom"
        :text="this.$t('customeToolTip.clearSearch')"
      >
        <BaseButton icon="mdi-close" fab tertiary class="search-close" />
      </CustomTooltip>
    </div>
  </div>

  <!-- Magnifier button -->
  <div v-else class="">
    <CustomTooltip position="bottom" :text="this.$t('input.searchLabel')">
      <v-icon
        data-search="open-search-box"
        class="search-icon"
        size="20"
        @click="openSearchBar"
      >
        mdi-magnify
      </v-icon>
    </CustomTooltip>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
</style>
